@if (formControl()) {
<div class="date">
    <mat-form-field class="form-field">
        <input matInput [placeholder]="meta().name" class="form-control input-date" [formControl]="formControl()!"
            [matDatepicker]="datepicker" [readonly]="readonly()" />
        @if (formControl()?.value && !meta().readonly && !readonly()) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="onClear()">
            <mat-icon>close</mat-icon>
        </button>
        }
        <mat-hint><strong>{{meta().info}}</strong></mat-hint>
        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
        <mat-datepicker #datepicker></mat-datepicker>
        @if (formControl()?.hasError('required')) {
        <mat-error>
            {{meta().name}} is <strong>required</strong>
        </mat-error>
        }
        @if (formControl()?.hasError('form')) {
        <mat-error>
            {{formError}}
        </mat-error>
        }
    </mat-form-field>
</div>
}
